var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('b-container',{attrs:{"fluid":""}},[_c('router-view'),_c('b-overlay',{attrs:{"show":_vm.isLoading,"no-wrap":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }